/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StaffOverviewEntry } from './StaffOverviewEntry';
import {
    StaffOverviewEntryFromJSON,
    StaffOverviewEntryFromJSONTyped,
    StaffOverviewEntryToJSON,
} from './StaffOverviewEntry';

/**
 * 
 * @export
 * @interface UsersFindAllResponse
 */
export interface UsersFindAllResponse {
    /**
     * 
     * @type {number}
     * @memberof UsersFindAllResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof UsersFindAllResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof UsersFindAllResponse
     */
    has_next: boolean;
    /**
     * 
     * @type {number}
     * @memberof UsersFindAllResponse
     */
    total: number;
    /**
     * 
     * @type {Array<StaffOverviewEntry>}
     * @memberof UsersFindAllResponse
     */
    data: Array<StaffOverviewEntry>;
}

/**
 * Check if a given object implements the UsersFindAllResponse interface.
 */
export function instanceOfUsersFindAllResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function UsersFindAllResponseFromJSON(json: any): UsersFindAllResponse {
    return UsersFindAllResponseFromJSONTyped(json, false);
}

export function UsersFindAllResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersFindAllResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
        'total': json['total'],
        'data': ((json['data'] as Array<any>).map(StaffOverviewEntryFromJSON)),
    };
}

export function UsersFindAllResponseToJSON(value?: UsersFindAllResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
        'total': value.total,
        'data': ((value.data as Array<any>).map(StaffOverviewEntryToJSON)),
    };
}

